import { CRUD } from "@/shared/components";
import {
  RevenueShareReportsListQuery,
  type RevenueShareReportsListRow,
} from "@/admin/entities/revenueShareReports";
import { BillingReportsConfig, BillingReportsSchemas } from "../model";

/** Отчёты доли с продаж по всем ревшер-организациям (спека §5). */
export function BillingReports() {
  return (
    <CRUD<RevenueShareReportsListRow>
      listQuery={RevenueShareReportsListQuery}
      getTableData={BillingReportsConfig.getTableData}
      mapColumns={BillingReportsConfig.mapColumns}
      columns={BillingReportsConfig.getColumnsConfig()}
      totalSchema={BillingReportsConfig.getTotalSchema()}
      filterSchema={BillingReportsSchemas.filterSchema}
      normalizeFilter={BillingReportsSchemas.normalizeFilter}
      texts={BillingReportsConfig.getTextsConfig()}
      persistFilters
      hideCreateButton
      useMobileView
      mobileColumns={BillingReportsConfig.getMobileColumnsConfig()}
    />
  );
}
